import Head from 'app/components/Head'
import Img from 'app/components/Image'
import Button from 'components/Buttons/Button'
import Icon from 'components/Icon'
import Layout from 'components/Layouts/Layout'
import React from 'react'

interface Props {
    status: number
}

function ErrorPage(props: Props) {
    const { status } = props

    const title = {
        503: 'Service Unavailable',
        500: 'Server Error',
        404: 'Page Not Found',
        410: 'Page was deleted',
        403: 'Forbidden',
        999: 'Javascript not allowed'
    }[status]

    const description = {
        503: 'Sorry, we are doing some maintenance. Please check back soon.',
        500: 'There has been an error. Please return to homepage.',
        404: 'There has been an error. Please return to homepage.',
        410: 'Page was deleted. Please return to homepage.',
        403: "You don't have permissions to access this page.",
        999: 'Please allow Javascript for all page functions.'
    }[status]

    const link = typeof (window) !== 'undefined' ? window?.location.hostname : '';
    return (
        <div className="min-h-screen bg-black flex w-full relative">
            <main className={`w-full z-0 relative flex flex-col text-white max-h-screen overflow-y-auto overflow-x-hidden`}>
                <Head title="Error occured | Timea" >

                    <meta property="og:title" content="Error | Timea" />
                    <meta property="og:url" content={link} />
                </Head>
                <div className="flex justify-center items-center mob:overflow-hidden mob:w-full mob:justify-center">
                    {/* <Img className="self-end -mb-50px mob:absolute mob:self-start mob:mt-40px mob:z-0 mob:w-110px left-0" src="/assets/img/404-left.png" alt="Květina | Serafin byliny" /> */}
                    <div className="flex flex-col items-center mt-80px mob:px-24px mob:mt-24px mob:z-10">
                        {
                            status != 999
                                ? <h1 className="text-128 font-bold">{status}</h1>
                                : <h1 className="text-128 font-bold flex items-center gap-30px">Javascript <img className="h-80px my-16px rounded" src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Unofficial_JavaScript_logo_2.svg/512px-Unofficial_JavaScript_logo_2.svg.png" alt="Javascript | Timea" /></h1>
                        }
                        <h2 className="text-36 mt-0 mb-32px font-bold mob:text-center">{title}</h2>
                        <div className="mob:text-center">{description}</div>
                        <Button href="/" defaultColor={false} className="bg-txtBlack text-white mt-32px sm:w-full"><Icon name="home" className="mr-16px" />Back to homepage</Button>
                    </div>
                    {/* <Img className="self-start mt-40px mob:absolute mob:right-0 mob:z-0 mob:w-110px" src="/assets/img/404-right.png" alt="Květina | Serafin byliny" /> */}
                </div>
            </main>

        </div>

    )
}

export default ErrorPage
